import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import { useEventContext } from "../../../context";
import { Button, Modal, Nav, NavItem, Tab, Tabs } from "react-bootstrap";
import Loading from "../../Loading";
import Episodes from "./Episodes";
import Episode from "./ModalTabs/Episode";
import { createMember, deleteMember, getEpisodes, getMembers, updateMember, updateMemberPhoto } from "../../../../api/cp";
import Members from "./Members";
import Member from "./Member";
import EpisodeMembers from "./ModalTabs/EpisodeMembers";
import Partners from "./ModalTabs/Partners";
import Videos from "./ModalTabs/Videos";
import Tags from "./ModalTabs/Tags";
import Materials from "./ModalTabs/Materials";
import { getStreamDays } from "../../../helpers/timeHelper";

const MemberModal = ({ show, member, onClose, onChange, onChangePhoto }) => {
    return (
        <Modal show={show} onHide={onClose} bsSize="large">
            <Modal.Header closeButton>
                <Modal.Title>Участник трансляции</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {null !== member &&
                    <Member
                        member={member}
                        onChange={onChange}
                        onChangePhoto={onChangePhoto}
                    />
                }
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onClose}>Закрыть</Button>
            </Modal.Footer>
        </Modal>
    );
}

const MembersModal = ({ show, members, onClose, onSelect, onCreate, onDelete }) => {
    return (
        <Modal show={show} onHide={onClose} bsSize="large">
            <Modal.Header closeButton>
                <Modal.Title>Участники трансляции</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {null !== members && <Members
                    members={members}
                    onSelect={onSelect}
                    onCreate={onCreate}
                    onDelete={onDelete}
                />}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onClose}>Закрыть</Button>
            </Modal.Footer>
        </Modal>
    );
}

const EpisodeModal = ({ episodes, membersEnabled, stream, streamDaysOptions, eventKey, show, episode, onClose }) => {
    return (
        <Modal show={show} bsSize="large" onHide={onClose} dialogClassName="modal-dialog-width-90p modal-dialog-height-90p">
            <Modal.Header closeButton>
                <Modal.Title>{episode?.delay ? 'Перерыв' : 'Эпизод'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {episode !== null && (
                    <Tabs
                        id="episode-tabs"
                        defaultActiveKey="Episode"
                    >
                        <Tab
                            eventKey="Episode"
                            title="Основная информация"
                        >
                            <Episode id={episode?.id} episodes={episodes} streamDaysOptions={streamDaysOptions} stream={stream} />
                        </Tab>
                        <Tab
                            eventKey="Partners"
                            title="Партнеры"
                        >
                            <Partners episode={episode} />
                        </Tab>
                        {membersEnabled &&
                            <Tab
                                eventKey="EpisodeMembers"
                                title="Участники"
                                disabled={episode.delay}
                            >
                                <EpisodeMembers
                                    eventKey={eventKey}
                                    episode={episode}
                                />
                            </Tab>
                        }
                        <Tab
                            eventKey="Videos"
                            title="Видео"
                            disabled={episode.delay}
                        >
                            <Videos episode={episode} />
                        </Tab>
                        <Tab
                            eventKey="Materials"
                            title="Материалы"
                            disabled={episode.delay}
                        >
                            <Materials episode={episode} />
                        </Tab>
                        <Tab
                            eventKey="Tags"
                            title="Теги"
                            disabled={episode.delay}
                        >
                            <Tags
                                eventKey={eventKey}
                                episode={episode}
                            />
                        </Tab>
                    </Tabs>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onClose}>Закрыть</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default () => {
    const { event } = useEventContext();
    const [stream, setStream] = useState(event.stream[0]);
    const [episodes, setEpisodes] = useState([]);
    const [episode, setEpisode] = useState(null);
    const [members, setMembers] = useState(null);
    const [showMembers, setShowMembers] = useState(null);
    const [member, setMember] = useState(null);

    useEffect(() => {
        setEpisodes([]);
        getEpisodes(stream.id)
            .then(episodes => setEpisodes(episodes?.sort((a, b) => a.timeStart === b.timeStart ? a.id - b.id : a.timeStart - b.timeStart) || []))
            ;
    }, [stream]);

    useEffect(() => {
        getMembers(event.client.id, {}, event.eventKey)
            .then(members => setMembers(members || []))
            ;
    }, []);

    const onMemberChange = async (memberId, data) => {
        let response;
        if (memberId) {
            response = await updateMember(memberId, data);
        } else {
            response = await createMember(event.client.id, data, event.eventKey);
        }

        const newMembers = members.slice();
        const index = newMembers.findIndex(({ id }) => id === memberId);
        if (-1 === index) {
            newMembers.push(response);
        } else {
            newMembers[index] = { ...newMembers[index], ...response };
        }
        setMembers(newMembers);

        return response;
    }
    const onMemberDelete = (memberId) => deleteMember(memberId)
        .then(() => {
            setMembers(members.filter(({ id }) => id !== memberId));
        });

    const onMemberChangePhoto = (memberId, file) => updateMemberPhoto(memberId, file)
        .then((data) => {
            const newMembers = members.slice();
            const index = newMembers.findIndex(({ id }) => id === memberId);
            if (-1 === index) {
                return;
            }
            newMembers[index] = { ...newMembers[index], ...data };
            setMembers(newMembers);

            return data;
        });

    const streamDaysOptions = getStreamDays(stream.timeStart, stream.timeStop).map(day => ({ value: day, label: moment(day).format('DD.MM.YYYY') }));

    if (null === members) {
        return <Loading />
    }

    return (
        <>
            <MemberModal
                show={!!member}
                member={member}
                onClose={() => setMember(null)}
                onChange={onMemberChange}
                onChangePhoto={onMemberChangePhoto}
            />
            <MembersModal
                show={showMembers && !member}
                members={members}
                onClose={() => setShowMembers(null)}
                onSelect={setMember}
                onCreate={() => setMember({})}
                onDelete={onMemberDelete}
            />
            <EpisodeModal
                episodes={episodes}
                stream={stream}
                streamDaysOptions={streamDaysOptions}
                membersEnabled={event.moduleEpisode.membersEnabled}
                eventKey={event.eventKey}
                show={episode && !showMembers && !member}
                episode={episode}
                onClose={() => setEpisode(null)}
                members={members}
                onShowMembers={setShowMembers}
            />
            <Nav bsStyle="tabs" activeKey={stream} onSelect={setStream}>
                {event.stream.map((stream) => (
                    <NavItem key={stream.id} eventKey={stream}>{stream.description_ru}</NavItem>
                ))}
            </Nav>
            <Episodes
                episodes={episodes}
                setEpisodes={setEpisodes}
                streamDaysOptions={streamDaysOptions}
                event={event}
                stream={stream}
                onEdit={setEpisode}
            />
        </>
    );
}
